// removed by extract-text-webpack-plugin
module.exports = {"text":"text-1f3W_","link":"link-3TD4m","button":"button-25r2G","buttondisabled":"buttondisabled-tRlg8","menu":"menu-1SzSY","divblock":"divblock-1ZhtY","th":"th-2cCyd"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/auto-import-list/style.scss
 ** module id = 48
 ** module chunks = 0
 **/